import { Box, Stack, Typography } from '@mui/material';
import { ImageAd, sx } from './sx';

interface ProductItemProps {
    srcImage: string;
    title: string;
    quantity?: string;
}

const ProductItem = ({ srcImage, title, quantity }: ProductItemProps) => {
    const { css } = sx();
    return (
        <Stack alignItems={'center'} spacing={1} direction={'row'}>
            <Box
                sx={{ ...css.box.image }}>
                <ImageAd
                    alt={''}
                    src={srcImage} />
            </Box>

            <Stack>
                <Typography sx={{ ...css.texts.title }}>
                    {title ?? ''}
                </Typography>
                {quantity &&
                    <Typography
                        sx={{ ...css.texts.quantity }}
                        variant='body1'>{`Quantidade: ${quantity}`}</Typography>
                }
            </Stack>
        </Stack>
    );
};

export { ProductItem };
